export default {
  title: 'GGMOMOMO COIN',
  tokenName: 'GGMOMOMO COIN',
  description: 'GGMOMOMO is a Meme Coin launched through the PUF platform and an important mysterious on-chain asset connected to the GGMOMOMO gaming ecosystem.\n\nGGMOMOMO is not designed as a utility token for any single game. Its role is more broadly centered around the entire GGMOMOMO gaming ecosystem, and it will gradually come into play as more games, applications, and players join the ecosystem.\n\nAt this stage, the ultimate use of GGMOMOMO remains unknown. We hope that, as the ecosystem grows, it will naturally develop its own positioning while preserving unlimited possibilities.',
  buyGgmomomo: 'Buy GGMOMOMO',
  openInfo: 'Open GGMOMOMO information',
  close: 'Close GGMOMOMO information',
} as const;
